// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { CUnmanagedResourceActivity_abstract } from './../abstract/SagaSchema/CUnmanagedResourceActivity_abstract';
export class CUnmanagedResourceActivity extends CUnmanagedResourceActivity_abstract {}
